<template>
  <div class="frame">
    <button
      class="newBlock"
      v-for="block in blocks"
      v-bind:key="block.id"
      :id="block.id"
      v-bind:style="{backgroundColor: block.color}"
      @touchstart="buttonClicked($event)"
      @touchend="buttonReset($event)"
    >
      <audio id="sound">
        <source type="audio/mp3" :src="require(`@/assets/${block.file}`)">
        <!-- <source src="../assets/g3.mp3" type="audio/mp3"> -->
      </audio>
      <div></div>
    </button>
  </div>
</template>

<script>
export default {
  name: "Frame",
  data: function() {
    return {
      blocks: [
        {
          id: "block1",
          color: "rgba(255, 0, 0, 1)",
          file: "g3.mp3"
        },
        {
          id: "block2",
          color: "rgba(0, 0, 255, 1)",
          file: "b3.mp3"
        },
        {
          id: "block3",
          color: "rgba(255, 255, 0, 1)",
          file: "d3.mp3"
        },
        {
          id: "block4",
          color: "rgba(0, 255, 0, 1)",
          file: "g4.mp3"
        }
      ]
    };
  },
  methods: {
    buttonClicked: function() {
      // alert("Hi");
      let thisButton = event.target;
      thisButton.style.opacity = "0.8";
      const sound = thisButton.firstElementChild;
      sound.play();
    },
    buttonReset: function() {
      let thisButton = event.target;
      thisButton.style.opacity = "1";
      const sound = document.getElementById("sound");
      sound.load();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.frame {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: black;
  .newBlock {
    width: 50vw;
    height: 50vh;
    border: 1px solid white;
    transition: 0.2s ease all;
  }
}
</style>
